import customerSupport from 'assets/content/customerSupportContactDetails.json';
import b2cContent from 'assets/content/b2cContent';
import b2bContent from 'assets/content/b2bcontent';
import comviqContent from 'assets/content/comviqContent';
import b2cTerms from 'assets/content/b2cTerms.json';
import b2bTerms from 'assets/content/b2bTerms.json';
import comviqTerms from 'assets/content/comviqTerms.json';
import { CustomerTypes } from 'Constants';

export const getContentFor = (customerType) => {
  switch (customerType) {
    case CustomerTypes.FUTUR_COMVIQ:
      return comviqContent;
    case CustomerTypes.FUTUR:
      return b2cContent;
    case CustomerTypes.FUTUR_MICRO:
    case CustomerTypes.MELODY:
    default:
      return b2bContent;
  }
};

export const getTermsFor = (customerType) => {
  switch (customerType) {
    case CustomerTypes.FUTUR_COMVIQ:
      return comviqTerms;
    case CustomerTypes.FUTUR:
      return b2cTerms;
    case CustomerTypes.FUTUR_MICRO:
    case CustomerTypes.MELODY:
    default:
      return b2bTerms;
  }
};
const addContactPhoneNumberToText = (content, customerType) => {
  const contactNumber = customerSupport.phoneNumber[String(customerType)];
  return content.replace('{{supportPhone}}', contactNumber);
};

export default addContactPhoneNumberToText;
